module.exports = __webpack_public_path__ + "img/mc-donalds-red.91ea6649.png";